common.View.create('map::canvas.blocks.modules.map.Block', {
    onDOMLoad() {
        const mapElement = this.element.find('[data-map-canvas]').get(0);

        if (!mapElement) {
            return;
        }

        const locations = this.parseLocations(mapElement.dataset.locations);

        if (locations.length === 0) {
            return;
        }

        if (typeof L === 'undefined') {
            let check = setInterval(() => {
                if (typeof L !== 'undefined') {
                    clearInterval(check);
                    this.initMap(mapElement, locations);
                }
            }, 100);
            return;
        }

        this.initMap(mapElement, locations);
    },

    parseLocations(locationsRaw) {
        if (!locationsRaw) {
            return [];
        }

        try {
            const parsed = JSON.parse(locationsRaw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    },

    initMap(mapElement, locations) {
        const firstLocation = locations[0];
        const center = [parseFloat(firstLocation.lat), parseFloat(firstLocation.lng)];
        const zoom = parseInt(firstLocation.zoom || 12, 10);

        const map = L.map(mapElement, { zoomControl: true }).setView(center, zoom);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(map);

        const markerIcon = L.divIcon({
            html: '<i class="fa-solid fa-location-dot text-primary text-3xl" style="filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));"></i>',
            className: 'fa-marker',
            iconSize: [30, 36],
            iconAnchor: [15, 36],
            popupAnchor: [0, -36],
        });

        const bounds = L.latLngBounds();

        locations.forEach((location) => {
            if (location.lat === null || location.lng === null) {
                return;
            }

            const position = [parseFloat(location.lat), parseFloat(location.lng)];

            const marker = L.marker(position, {
                icon: markerIcon,
                title: location.name || '',
            }).addTo(map);

            marker.bindPopup(this.buildInfoContent(location));

            bounds.extend(position);
        });

        if (locations.length > 1) {
            map.fitBounds(bounds, { padding: [30, 30] });
        }
    },

    buildInfoContent(location) {
        const wrapper = document.createElement('div');
        wrapper.className = 'map-info-window';

        if (location.name) {
            const name = document.createElement('div');
            name.className = 'map-info-window__name';
            name.textContent = location.name;
            wrapper.appendChild(name);
        }

        if (location.address) {
            const address = document.createElement('div');
            address.className = 'map-info-window__address';
            address.textContent = location.address;
            wrapper.appendChild(address);
        }

        if (location.website) {
            const link = document.createElement('a');
            link.className = 'map-info-window__link';
            link.href = this.normalizeWebsite(location.website);
            link.target = '_blank';
            link.rel = 'noopener';
            link.textContent = location.website;
            wrapper.appendChild(link);
        }

        return wrapper;
    },

    normalizeWebsite(website) {
        if (!website) {
            return '';
        }

        if (/^https?:\/\//i.test(website)) {
            return website;
        }

        return `https://${website}`;
    },
});
